import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { updateNotificationContactEndpoint } from '../../../services/notificationContactEndPoints';
import { INotificationContact } from 'interfaces/notification.interface';

export const updateNotificationContactThunk = createAsyncThunk(
  'updateNotificationContact',
  async (data: INotificationContact) => {
    try {
      const endpoint = updateNotificationContactEndpoint(data);
      return await apiFetch<Partial<INotificationContact>>(endpoint).then(
        (res) => res?.data || null
      );
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('updateNotificationContact catch:', message);
      throw Error(message);
    }
  }
);
